import script from "./SlideView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SlideView.vue?vue&type=script&setup=true&lang=ts"

import "./SlideView.vue?vue&type=style&index=0&id=03a5de7d&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03a5de7d"]])

export default __exports__